export default __webpack_public_path__ + "static/media/Product-List.cf614328.jpg";